import { gql } from '@apollo/client';
import type { ListOrderPoolPageVariables } from './routePlanningOrderPool';

/** 导出入参 = 列表查询同款 request（分页由后端忽略） */
export type DownloadRouteOrderPoolExportVariables = ListOrderPoolPageVariables;

export interface DownloadRouteOrderPoolExportResponse {
  downloadRouteOrderPoolExport: string;
}

export interface DownloadRouteOrderPoolExportForDspResponse {
  downloadRouteOrderPoolExportForDsp: string;
}

/**
 * 导出运单池明细（WMS）：按当前筛选导出全部匹配，返回下载中心文件名。
 */
export const DOWNLOAD_ROUTE_ORDER_POOL_EXPORT = gql`
  mutation DownloadRouteOrderPoolExport($request: ListOrderPoolPageRequestInput!) {
    downloadRouteOrderPoolExport(request: $request)
  }
`;

/**
 * 导出运单池明细（DSP）。
 */
export const DOWNLOAD_ROUTE_ORDER_POOL_EXPORT_FOR_DSP = gql`
  mutation DownloadRouteOrderPoolExportForDsp($request: ListOrderPoolPageRequestInput!) {
    downloadRouteOrderPoolExportForDsp(request: $request)
  }
`;
